module.exports = __webpack_public_path__ + "img/statistics.9670bd51.png";